import { COLLECTION_TOPICS } from "@lib/config/mercureSubscriptions";
import { useMercure } from "@lib/hooks/useMercure";
import type { QueryKey } from "@tanstack/react-query";

/**
 * Hook for Mercure real-time integration with table data.
 * Uses "invalidate" strategy (refetch on update) — compatible with server-paginated tables.
 *
 * @param options.resource      — API fetch resource path (e.g. "/tickets")
 * @param options.mercureTopic  — canonical Mercure collection topic (with `/api` prefix).
 *                                Resolves to `COLLECTION_TOPICS[resource]` when omitted, then
 *                                falls back to the raw `resource` (keeps non-wired tables unchanged).
 * @param options.enabled       — Whether Mercure subscription is active
 * @param options.queryKey      — React Query key to invalidate on update
 */
export function useTableMercure({
  resource,
  mercureTopic,
  enabled = false,
  queryKey,
}: {
  resource: string;
  mercureTopic?: string;
  enabled?: boolean;
  queryKey: QueryKey;
}): void {
  const topic = mercureTopic ?? COLLECTION_TOPICS[resource] ?? resource;

  useMercure(topic, {
    enabled,
    queryKey: queryKey as any[],
    onUpdate: "invalidate",
    onError: (err: Error) => console.warn("useTableMercure:", err),
  });
}
